import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00032 } from '../../../../P00032';
import { P00030 } from '../../../../P00030';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P0003600SeuilTemperatureFiltration2424 } from '../../../Enum/P0003600SeuilTemperatureFiltration2424';
import {
  P0003600ProgrammeFiltrationAuto,
  P0003600ProgrammeFiltrationAutoSans,
} from '../../../Enum/P0003600ProgrammeFiltrationAuto';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { convertMinutesToTime } from '../../../../../../helper/convertSecondsToTime';
import { P0003600DureeAjustementLoiEau } from '../../../Enum/P0003600DureeAjustementLoiEau';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { GlobalModalRemoveComponent } from '../../../../../../../../components/global-modal-remove/global-modal-remove.component';
import { P0003600EnSavoirPlusComponent } from '../../enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p0003600-filtration-mise-en-oeuvre-filtration-eau-bassin',
  templateUrl:
    './p0003600-filtration-mise-en-oeuvre-filtration-eau-bassin.component.html',
  styleUrls: [
    './p0003600-filtration-mise-en-oeuvre-filtration-eau-bassin.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    LabelConfigurationComponent,
    MinuterieLabelComponent,
    LargedLinkComponent,
    TwoChoicesControlComponent,
    LabelDescriptionComponent,
  ],
})
export class P0003600FiltrationMiseEnOeuvreFiltrationEauBassinComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: P0003600EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotJourPPH'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage3,
        'fsPHorlogePicotJourPPH',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotSemainePPH'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage3,
        'fsPHorlogePicotSemainePPH',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingsClockPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotJourPPE'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage2,
        'fsPHorlogePicotJourPPE',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotSemainePPE'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage2,
        'fsPHorlogePicotSemainePPE',
        hj,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003600SeuilTemperatureFiltration2424 =
    P0003600SeuilTemperatureFiltration2424;
  protected readonly P0003600ProgrammeFiltrationAuto =
    P0003600ProgrammeFiltrationAuto;
  protected readonly P0003600ProgrammeFiltrationAutoSans =
    P0003600ProgrammeFiltrationAutoSans;
  protected readonly convertMinutesToTime = convertMinutesToTime;
  protected readonly P0003600DureeAjustementLoiEau =
    P0003600DureeAjustementLoiEau;
}
